export type Order = 'asc' | 'desc';
export const RowsPerPageValues = [10, 25, 50, 100];
export type RowsPerPageOptions = (typeof RowsPerPageValues)[number];

function descendingComparator<T, K extends keyof T>(a: T, b: T, orderBy: K) {
	if (b[orderBy] < a[orderBy]) {
		return -1;
	}
	if (b[orderBy] > a[orderBy]) {
		return 1;
	}

	return 0;
}

//eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getComparator = (order: Order, orderBy: string) => {
	return order === 'desc'
		? //eslint-disable-next-line @typescript-eslint/no-explicit-any
			(a: any, b: any) => descendingComparator(a, b, orderBy)
		: //eslint-disable-next-line @typescript-eslint/no-explicit-any
			(a: any, b: any) => -descendingComparator(a, b, orderBy);
};

export { default as KeyphraseTableRow } from './KeyphraseRow';

export { default as EnhancedTable } from './EnhancedTable';
export { type EnhancedTableHeadCell } from './EnhancedTableHead';
// export { type EnhancedTableCell } from './EnhancedTableRow';
